import React from 'react'
import './Banner.sass'
import bannerGif from '../../resources/images/fmworld-banner.gif'

const Banner: React.FC = () => {
    return (
        <a href="https://www.fm-world.it/servizi/" target="_blank" rel="noopener noreferrer">
            <div className="banner-container">
                <img src={bannerGif} alt="FM-world banner ad" />
            </div>
        </a>
    )
}

export default Banner
